import { gql } from '@apollo/client';

/**
 * `split_order` returns the parent first, then the children in `split_seq` order.
 * Every returned order carries `order_id`, so Apollo writes the parent into the cache by its key.
 * The item lines are `itemsByOrderId` (the Hasura relationship), aliased to `items` for callers.
 * `p_children` is a `jsonb` variable: one `{ items, services, claims, shipper_billable }` per new order, in column
 * order. `items` holds `{ item_id }` for a whole line or `{ item_id, quantity }` for a portion. `services` is an array
 * of `service_id`s and `claims` an array of open `claim_id`s, both always sent (empty when the child has none); every
 * open claim on the parent must be listed under exactly one child. `shipper_billable` is the column's Billable switch.
 */
export const SPLIT_ORDER = gql`
    mutation SplitOrder($p_order_id: uuid!, $p_children: jsonb!, $p_child_status: String!) {
        split_order(args: { p_order_id: $p_order_id, p_children: $p_children, p_child_status: $p_child_status }) {
            order_id
            order_number
            order_status
            original_order_id
            split_seq
            shipper_billable
            invoicing_status
            shipper_invoice_id
            carrier_invoice_id
            middle_mile_carrier_invoice_id
            warehouse_carrier_invoice_id
            items: itemsByOrderId {
                item_id
                sku
                description
                quantity
            }
        }
    }
`;

/**
 * Sets `shipper_billable` on one order with a plain `update_orders_by_pk`: roles `user` and `onward-admin` can update the
 * column, and `orders_on_update` reprices the order. The selection carries `order_id` (Apollo updates the cached order by
 * it) and the invoice fields the toggle reads.
 */
export const SET_SHIPPER_BILLABLE = gql`
    mutation SetShipperBillable($order_id: uuid!, $shipper_billable: Boolean!) {
        update_orders_by_pk(pk_columns: { order_id: $order_id }, _set: { shipper_billable: $shipper_billable }) {
            order_id
            shipper_billable
            invoicing_status
            shipper_invoice_id
            carrier_invoice_id
            middle_mile_carrier_invoice_id
            warehouse_carrier_invoice_id
        }
    }
`;
